
import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <main className="min-h-screen bg-white pt-24">
      <div className="container mx-auto px-4 py-12">
        <nav className="text-sm text-gray-500 mb-4">
          <Link to="/" className="hover:underline">Главная</Link> {' > '} <span className="font-semibold">О нас</span>
        </nav>

        <div className="text-center mb-12 pt-8">
          <h1 className="font-cormorant-garamond text-5xl font-bold mb-4">О НАС</h1>
        </div>

        <div className="max-w-4xl mx-auto space-y-12">
          <section>
            <div className="space-y-6 text-gray-700">
              <p>
                Создавая свечи из натурального природного воска во имя красоты, Budnik Bee Garden стремится возвысить природу до уровня искусства, чтобы сохранить и передать ее наследие и величие будущим поколениям.
              </p>
              <p>
                Рука об руку с нашими единомышленниками и покупателями, разделяющими наши взгляды, мы работаем над тем, чтобы вместе создавать более красивый и ответственный мир.
              </p>
              <p className="italic text-lg">
                С интерьерными свечами и ароматическими диффузорами Budnik Bee Garden каждый момент становится особенным. Пусть их совершенная форма и завораживающий аромат принесут в ваш дом неповторимую атмосферу уюта и роскоши.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant-garamond text-3xl font-semibold mb-6">Устойчивое развитие</h2>
            <div className="space-y-6 text-gray-700">
              <p>
                Мы постоянно отслеживаем актуальные аспекты применения растительных и натуральных восков, масел и эссенций в свете изменения климата в рамках зеленой экономики замкнутого цикла.
              </p>
              <p>
                Мы продолжаем укрепление международного сотрудничества в условиях устойчивого развития и глобальной трансформации.
              </p>
              <p>
                Наша приверженность устойчивому развитию формирует наш выбор — от выбора поставщиков сырья до упаковки.
              </p>
              <p>
                Мы стремимся к достижению правильного баланса между эстетикой и использованием переработанных, перерабатываемых и биоразлагаемых материалов.
              </p>

              <ul className="list-disc pl-6 space-y-3">
                <li>Мы отправляем все наши заказы в фирменных транспортных коробках, которые включают призыв к действию по повторному использованию и переработке упаковки.</li>
                <li>Вся наша вторичная упаковка и транспортные коробки изготовлены из сертифицированной бумаги.</li>
                <li>Вся наша упаковка имеет инструкции по переработке и может быть повторно переработана либо использоваться вторично.</li>
              </ul>

              <p>
                Не идя на компромиссы в отношении функциональности и качества, мы постоянно стремимся сделать наши формулы чистыми, используя как можно больше натуральных ингредиентов.
              </p>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default About;
